import { useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";

import SimpleModal from "../../../components/common/SimpleModal";
import CountryForm from "./form/CountryForm";
import { setUpdateCountry } from "../redux/countrySlice";

const CountryTable = ({ data }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  const handleEdit = (data) => {
    setShowModal(true);
    dispatch(
      setUpdateCountry({
        id: data.id,
        name: data.name,
        imageUrl: data?.imageUrl,
      })
    );
  };

  return (
    <>
      <SimpleModal
        show={showModal}
        handleClose={handleCloseModal}
        title="ແກ້ໄຂຂໍ້ມູນປະເທດ"
        size="md"
      >
        <CountryForm handleClose={handleCloseModal} />
      </SimpleModal>
      <Table bordered responsive>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່</strong>
            </th>
            <th className="text-center">
              <strong>ຮູບ</strong>
            </th>
            <th className="text-center">
              <strong>ແກ້ໄຂ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center">{d.name}</td>
                <td className="text-center">
                  <img
                    width={40}
                    src={d.imageUrl}
                    alt="country"
                    className="img-thumbnail"
                  />
                </td>
                <td className="text-center">
                  <div
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    onClick={() => handleEdit(d)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default CountryTable;
